@import '../../../global/host-utils.scss';

$component-height-big: 40px; // figma: big (40px)
$component-height-medium: 32px; // figma: medium (32px)
$component-height-small: 26px; // figma: not used
$component-height-extra-small: 18px; // figma: small (18px)
$focus-offset-default: 2px;
$focus-offset-extra-small: 1px;

:host {
  @include ipl-host-reset;
  display: inline-block;
  @include ipl-font-bold-smaller; // 14px
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
}

.button-element {
  width: 100%;
  height: 100%;
  padding-left: 16px;
  padding-right: 16px;
  background: inherit;
  letter-spacing: var(--letter-spacing-basic);
  text-transform: uppercase;
  cursor: pointer;
  @include ipl-text-ellipsis;

  height: $component-height-big;
  &.M,
  &.medium {
    height: $component-height-medium;
  }
  &.S,
  &.small {
    height: $component-height-small;
  }
  &.XS,
  &.extra-small {
    height: $component-height-extra-small;
    @include ipl-font-bold-extra-small; // 12px
  }

  &.disabled {
    color: var(--texttoggle-text-disabled);
    fill: var(--texttoggle-text-disabled);

    &.selected {
      background-color: var(--texttoggle-surface-disabled);
    }
  }

  // selected state
  &.selected:not(.disabled) {
    background-color: var(--texttoggle-surface-primary);
    color: var(--texttoggle-text-default);
    fill: var(--texttoggle-text-default);

    // suppress hover state on mobile devices
    @media (hover: hover) {
      &:hover:not(:active) {
        color: var(--texttoggle-text-hover-selected);
        fill: var(--texttoggle-text-hover-selected);
      }
    }
  }

  // unselected state
  &:not(.selected, .disabled) {
    color: var(--texttoggle-text-unselected);
    fill: var(--texttoggle-text-unselected);

    // suppress hover state on mobile devices
    @media (hover: hover) {
      &:hover:not(:active) {
        color: var(--texttoggle-text-hover-unselected);
        fill: var(--texttoggle-text-hover-unselected);
      }
    }
  }

  // active - unselected
  &:active:not(.selected) {
    background-color: var(--texttoggle-surface-disabled);
    color: var(--texttoggle-text-active);
    fill: var(--texttoggle-text-active);
  }

  // focus
  &:focus-visible {
    outline: 3px solid black;
    outline-offset: $focus-offset-default;
    &.extra-small {
      outline-offset: $focus-offset-extra-small;
    }
  }
}

.pts-expansion-upper {
  position: absolute;
  top: 0;
  height: 0;
  left: 0;
  cursor: pointer;

  &.colorize-pts {
    background-color: rgba(255, 0, 0, 0.3);
  }

  &.M,
  &.medium {
    top: -5px;
    height: 8px;
  }
  &.S,
  &.small {
    top: -9px;
    height: 11px;
  }
  &.XS,
  &.extra-small {
    top: -13px;
    height: 15px;
  }
}

.pts-expansion-lower {
  position: absolute;
  top: 0;
  height: 0;
  left: 0;

  cursor: pointer;
  &.colorize-pts {
    background-color: rgba(255, 0, 0, 0.3);
  }

  &.M,
  &.medium {
    top: calc($component-height-medium + 2px);
    height: 8px;
  }
  &.S,
  &.small {
    top: calc($component-height-small + 2px);
    height: 11px;
  }
  &.XS,
  &.extra-small {
    top: calc($component-height-extra-small + 2px);
    height: 15px;
  }
}
